// Each site shadows this file as they need it
const AvailabilitySubmissionMessage = () => null

export default AvailabilitySubmissionMessage
